// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid4S = class TeaserBoxInnerGrid4S extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            isPremium: this.teaserBoxConfig.isPremium,
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            showAuthorAvatar: false,
            showAuthorName: false,
            showCategory: false,
            showPublicationDate: this.teaserBoxConfig.showPublicationDate,
            showTitle: true,
            size: TileSize.S,
            titleOnImage: true,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
    }
};
TeaserBoxInnerGrid4S.moduleVersion = TeaserBoxVersion['4S'];
TeaserBoxInnerGrid4S = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid8S',
        components: { InnerGridWrapper, Tile },
        template: `
    <InnerGridWrapper class="--one-row">
      <Tile v-if="articles && articles.length"
            v-for="article in articles.slice(0, 4)" :key="article.id"
            v-bind="{ ...tileConfig, article, fallbackImage, windowService, isLazy, isMobile }" />
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid4S);
export { TeaserBoxInnerGrid4S };
